import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import axios from '../../axios';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Countdown from 'react-countdown';
import Logo, { LogoVariants } from '../../components/Logo';

const renderer = ({
  minutes,
  seconds,
}: {
  minutes: number;
  seconds: number;
}) => {
  return (
    <span data-testid="countdown">
      {minutes}:{seconds}
    </span>
  );
};

export default function ForgotPasswordCard(params: { email: string }) {
  const { t } = useTranslation();
  const { email } = params;

  const [verificationResent, setVerificationResent] = useState(false);

  const handleResend = async () => {
    await axios.post('api/auth/forgot-password', { email });
    setVerificationResent(true);
  };

  return (
    <Card
      sx={{
        maxWidth: '30%',
      }}
      data-testid="forgot-password-card"
    >
      <CardContent>
        <Logo variant={LogoVariants.small} />
        <Typography variant="h5" component="div">
          {t('FORGOT_PASSWORD.TITLE')}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            marginTop: '15px',
          }}
        >
          {t('FORGOT_PASSWORD.VERIFY.DESCRIPTION', { email })}
        </Typography>
      </CardContent>
      <CardActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button
          size="small"
          onClick={handleResend}
          disabled={verificationResent}
          data-testid="resendVerifyEmailButton"
        >
          {verificationResent
            ? t('VERIFICATION.RESEND_MESSAGE')
            : t('VERIFICATION.RESEND')}
        </Button>
        {verificationResent && (
          <Countdown
            date={Date.now() + 60000}
            renderer={renderer}
            onComplete={
              /* istanbul ignore next */
              () => {
                setVerificationResent(false);
              }
            }
          />
        )}
      </CardActions>
    </Card>
  );
}
